<template>
	<div class="wrapper" style="margin: 0 !important; margin-top: -20px">
		<!-- 서브 헤더 --------- start -->
		<v-layout wrap class="mb-2" align-center>
			<v-icon color="#9D9DB7">
				mdi-circle-small
			</v-icon>
			<span class="sub_header">마케팅 통계 관리</span>
		</v-layout>
		<!-- 서브 헤더 ----------- end -->

		<v-layout align-center class="header_search">
			<v-layout class="search_wrap">
				<v-layout>
					<v-flex class="search_select_type ml-4" style="width:200px; max-width:200px;">
						<selectBox :sel="surveySel" class="searchSel" @change="search_biz()"></selectBox>
					</v-flex>

					<v-flex class="search_select_type ml-4" style="width:200px; max-width:200px;">
						<selectBox :sel="surveySel_campaign" class="searchSel" @change="search_campaign()"></selectBox>
					</v-flex>
				</v-layout>

				<!-- 날짜 선택 --------- start -->
				<v-layout justify-end>
					<v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2' : 'search_date_1'">
						<DatepickerDialog :picker="termStartpicker"></DatepickerDialog>
					</v-flex>
					<span class="mx-1"> ~ </span>
					<v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2 ' : 'search_date_2'">
						<DatepickerDialog :picker="termEndpicker" :allowed_dates="termCustomer"> </DatepickerDialog>
					</v-flex>
					<v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
						<selectBox :sel="searchsel" @change="selectDays" :class="'searchSel'"></selectBox>
					</v-flex>
					<!-- 날짜 선택 --------- end -->

					<v-btn class="search_btn ml-4" color="#ff9419" @click="getTableData()"><v-icon>mdi-magnify</v-icon>조회</v-btn>

					<!-- 이름 검색 end  -->
					<!-- 계약자 업데이트 버튼 -->
					<v-btn class="search_btn_noWidth ml-2" color="#ff9419" @click="confirmUpdateClick()"
						><v-icon>mdi-refresh</v-icon>계약자 업데이트</v-btn
					>
				</v-layout>
			</v-layout>
		</v-layout>

		<!-- 데이터 테이블 ------start -->
		<v-layout wrap class="mr_whole_container mr_scroll">
			<v-flex xs12 column wrap class="marketing_report_graph_container mt-4 mb-4">
				<!-- 맨위 -->
				<v-layout d-flex class="marketing_report_graph_top pa-3" align-center>
					<!-- 1 -->
					<v-layout class="mrg_top_inner_left">
						<v-flex column>
							<div d-flex class="mrg_top_inner_item_top">통화 처리현황</div>
							<v-flex d-flex class="mrg_top_inner_item_bottom">
								<v-flex d-flex class="mr_inner_two_item mr_gray_700">
									<span>배분수량</span>
									<span>{{ this.call[0].value }}</span>
								</v-flex>
								<v-flex d-flex class="mr_inner_two_item mr_aqua_600">
									<span>처리</span>
									<span>{{ this.call[1].value }}</span>
								</v-flex>
								<v-flex d-flex class="mr_inner_item_bottom_left mr_inner_right_four_colors">
									<v-flex d-flex class="mr_inner_three_item" v-for="item in call.slice(3, 7)" :key="item.id">
										<span>{{ item.text }}</span>
										<span>{{ item.value }}</span>
										<span>[{{ getPercent(item.value, call.slice(3, 7)) }}%]</span>
									</v-flex>
								</v-flex>
								<v-flex d-flex class="mr_inner_two_item mr_gray_700">
									<span>미처리</span>
									<span>{{ this.call[2].value }}</span>
								</v-flex>
							</v-flex>
						</v-flex>
					</v-layout>
					<!-- 2 -->
					<v-layout class="mrg_top_inner_center" row wrap>
						<v-flex column>
							<div d-flex class="mrg_top_inner_item_top">성과현황</div>
							<v-flex d-flex class="mrg_top_inner_item_bottom">
								<v-flex d-flex class="mr_inner_two_item mr_gray_700">
									<span mr_gray_700>배분수량&nbsp;</span>
									<span>{{ performance[0].value }}</span>
								</v-flex>
								<v-flex d-flex class="mr_inner_two_item mr_aqua_600">
									<span>통화성공&nbsp;</span>
									<span>{{ performance[1].value }}</span>
								</v-flex>
								<v-flex d-flex class="mr_inner_item_bottom_left">
									<v-flex d-flex class="mr_inner_two_item mr_aqua_700">
										<span>방문예약&nbsp;</span>
										<span>{{ performance[2].value }}</span>
									</v-flex>
									<v-flex d-flex class="mr_inner_two_item">
										<span>상담완료&nbsp;</span>
										<span>{{ performance[3].value }}</span>
									</v-flex>
								</v-flex>
								<v-flex d-flex class="mr_inner_item_bottom_right mr_inner_left_three_colors">
									<v-flex d-flex class="mr_inner_two_item" v-for="item in performance.slice(4, 7)" :key="item.id">
										<span>{{ item.text }}</span>
										<span>{{ item.value }}</span>
									</v-flex>
								</v-flex>
							</v-flex>
						</v-flex>
					</v-layout>
					<!-- 3 -->
					<v-layout d-flex class="align-center ml-2 mrg_top_inner_right">
						<v-flex class="mrg_top_inner_right_wrapper">
							<v-flex column class="mr_inner_small_two_items">
								<v-flex row v-for="item in counselor.slice(0, 3)" :key="item.id">
									<span>{{ item.text }}</span>
									<span>{{ item.value }}</span>
								</v-flex>
							</v-flex>
							<v-flex column class="mr_inner_small_two_items">
								<v-flex row v-for="item in counselor.slice(3, 6)" :key="item.id">
									<span>{{ item.text }}</span>
									<span>{{ item.value }}</span>
								</v-flex>
							</v-flex>
						</v-flex>
					</v-layout>
				</v-layout>
				<!-- 좌우 flex -->
				<v-layout d-flex style="height: 90%; width: 100%; gap: 15px">
					<!-- 좌 -->
					<v-layout class="mrg_left_container" column>
						<v-layout class="marketing_report_graph_left_top mt-5 mb-5 mr-5" column>
							<span class="mrg_medium_txt">통화 처리 현황</span>
							<v-layout row style="flex-wrap: nowrap; align-items: center">
								<apexchart
									width="190"
									height="190"
									type="donut"
									:options="small_donut.chartOptions"
									:series="small_donut.series"
								></apexchart>
								<!-- 커스텀 플로팅 바 start -->
								<div class="mr_big_bar">
									<div class="mr_float_state">
										<div class="mr_float_inner" v-for="item in callBarData" :key="item.id">
											<span class="mr_float_inner_square" :style="{ color: item.color }">■</span>
											<span>{{ item.text }}</span>
										</div>
									</div>
									<!-- 커스텀 플로팅 바 end -->
									<!-- 커스텀 바 start -->
									<div class="mr_bar_container">
										<div class="mr_bar_outer" v-for="item in callBarData" :key="item.id">
											<div
												class="mr_bar_inner"
												:style="{
													// 데이터가 없으면 투명
													backgroundColor: item.value <= 0 ? 'transparent' : item.color,
													width: getPercent(item.value, callBarData) + '%',
												}"
											>
												<div class="mr_bar_inner_txt_left">
													{{ item.value }}
												</div>
											</div>
											<div class="mr_bar_inner_txt_right">
												{{ getPercent(item.value, callBarData) + '%' }}
											</div>
										</div>
									</div>
								</div>
								<!-- 커스텀 바 end -->
							</v-layout>
						</v-layout>
						<v-layout class="marketing_report_graph_left_bottom">
							<v-layout column class="mr_left_bottom_item" v-for="barData in twoBarsData" :key="barData.id">
								<!-- 제목 -->
								<span class="mrg_medium_txt align-self-start" style="white-space: nowrap;">{{ barData.title }}</span>

								<v-flex v-if="ready">
									<apexchart
										width="210"
										height="248"
										type="donut"
										:options="barData.chartOptions"
										:series="barData.value.map(v => v.value)"
									></apexchart>
								</v-flex>

								<!-- 커스텀 플로팅 바 start -->
								<v-flex class="mr_big_bar" style="width: 70%">
									<!-- 커스텀 플로팅 바 end -->
									<!-- 커스텀 바 start -->
									<div class="mr_bar_container" v-for="item in barData.value" :key="item.id">
										<div class="mr_bar_outer">
											<!-- 등급 -->
											<div class="mr_bar_inner_grade">{{ item.grade }}</div>

											<div
												class="mr_bar_inner"
												:style="{
													// 값이 없으면 투명
													backgroundColor: item.value <= 0.1 ? 'transparent' : item.color,
													width: getPercent(item.value, barData.value) + '%',
												}"
											>
												<!-- 값 -->
												<div class="mr_bar_inner_txt_left">
													{{ item.value === 0.1 ? 0 : item.value }}
												</div>
											</div>
											<!-- 퍼센트 -->
											<div class="mr_bar_inner_txt_right">
												{{ item.value === 0.1 ? '0%' : getPercent(item.value, barData.value) + '%' }}
											</div>
										</div>
									</div>
								</v-flex>
								<!-- 커스텀 바 end -->
							</v-layout>
						</v-layout>
					</v-layout>

					<!-- 우 -->
					<v-layout class="mrg_right_container" column>
						<v-layout class="marketing_report_graph_right_top mt-5 mb-5" column>
							<span class="mrg_medium_txt">팀별 마케팅 현황</span>
							<v-layout row wrap class="mrg_report_rigth_top_wrapper" style="flex: none !important; height: 100%">
								<!-- 컬럼 차트 컨테이너 -->
								<v-layout row wrap class="mr_chart_container">
									<!-- 커스텀 체크박스 바 start -->

									<v-layout class="mr_float_state" style="position: absolute; top: 10px; z-index: 100; margin-top: -12px !important;">
										<v-layout row class="mr_float_state_item mr_scroll" style="padding: 9px 0;">
											<v-checkbox
												v-for="(check, idx) in checkBoxList"
												:key="idx"
												:color="check.color"
												hide-details
												class="fontsize_13_checkbox mt-0 mr-3"
												:style="{ color: check.color }"
												v-model="check.checked"
												@change="checkSeries(idx)"
											>
												<template v-slot:label>
													<span :style="{ color: check.color }">{{ check.value }}</span>
												</template>
											</v-checkbox>
										</v-layout>
										<v-layout row justify-end>
											<v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
												<selectBox :sel="glsel" :class="'searchSel'" @change="ChangeGl()"></selectBox>
											</v-flex>
											<v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
												<selectBox :sel="hqsel" :class="'searchSel'" @change="ChangeHq()"></selectBox>
											</v-flex>
											<v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
												<selectBox :sel="teamsel" :class="'searchSel'" @change="ChangeTeam()"></selectBox>
											</v-flex>
										</v-layout>
									</v-layout>
									<!-- 컬럼 총괄 컨테이너 start -->
									<v-layout column style="align-self: flex-end; height: 10%">
										<!-- 스택 시작 -->
										<!-- 커스텀 스틱 컨테이너 start -->
										<div class="mr_stick_container">
											<div style="display: flex; z-index:9999;" class="mr_stick_wrapper">
												<!-- 팀 컨테이너 -->
												<div class="mr_team_stick_container" v-for="(gl, glIdx) in column_data" :key="glIdx">
													<div v-for="(hq, hqIdx) in gl.hqList" :key="hqIdx" style="flex-flow: nowrap; display: flex">
														<div v-for="(team, teamIdx) in hq.teamList" :key="teamIdx" style="position: relative; width: 100%;">
															<div class="mr_team_stick">
																<v-tooltip right open-delay="1000">
																	<template v-slot:activator="{ on, attrs }">
																		<span v-bind="attrs" v-on="on" class="ellipsis-text">{{ team.title }}</span>
																	</template>
																	<span>{{ team.title }}</span>
																</v-tooltip>
															</div>
														</div>
													</div>
												</div>
											</div>
											<!-- <div class="mr_team_stick">
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<span v-bind="attrs" v-on="on">{{ team.title }}</span>
																	</template>
																	<span>{{ team.title }}</span>
																</v-tooltip>
															</div> -->
											<!-- 본부 컨테이너 -->
											<div style="display: flex; z-index:9999;">
												<div class="mr_hq_stick_container" v-for="(gl, glIdx) in column_data" :key="glIdx">
													<div
														v-for="(hq, hqIdx) in gl.hqList"
														:key="hqIdx"
														class="mr_hq_stick"
														:style="{
															width: `calc(var(--mr-width) * ${getHqLength(hq)} + (var(--mr-gap) * (${getHqLength(hq)} - 1)))`,
														}"
													>
														<v-tooltip right open-delay="1000">
															<template v-slot:activator="{ on, attrs }">
																<span v-bind="attrs" v-on="on" class="ellipsis-text">{{ hq.name }}</span>
															</template>
															<span>{{ hq.name }}</span>
														</v-tooltip>
													</div>
												</div>
											</div>
											<!-- 총괄 컨테이너 -->
											<div style="z-index:9999;" class="mr_gl_stick_container">
												<div
													v-for="(gl, glIdx) in column_data"
													:key="glIdx"
													class="mr_gl_stick"
													:style="{
														width: `calc(var(--mr-width) * ${getGlLength(gl)} + (var(--mr-gap) * (( ${getGlLength(gl)} - 1 ) - (${
															gl.hqList.length
														} - 1 )) + ( var(--mr-big-gap) * (${gl.hqList.length} - 1)))`,
													}"
												>
													<v-tooltip right open-delay="1000">
														<template v-slot:activator="{ on, attrs }">
															<span v-bind="attrs" v-on="on" class="ellipsis-text">{{ gl.name }}</span>
														</template>
														<span>{{ gl.name }}</span>
													</v-tooltip>
												</div>
											</div>
											<div
												:style="`width:${40 + 125 * column.series[0].data.length + 6 * (column.series[0].data.length - 1)}px; left:-15px`"
											>
												<apexchart
													:key="chartKey"
													class="mr_column_graph"
													type="bar"
													width="100%"
													height="300"
													:options="column.chartOptions"
													:series="getSeries(column.series)"
													ref="columnChart"
												></apexchart>
											</div>
										</div>
										<!-- 커스텀 스틱 컨테이너 end -->
										<!-- 스택 끝 -->
									</v-layout>
								</v-layout>
							</v-layout>
						</v-layout>

						<v-layout class="marketing_report_graph_right_bottom" column>
							<v-layout row wrap align-center justify-space-between>
								<span class="mrg_medium_txt">기간별 마케팅 현황</span>
								<div class="mr_float_state" style="justify-content: flex-end; width: auto">
									<v-checkbox
										v-for="(check, idx) in checkBoxList2"
										:key="idx"
										:color="check.color"
										hide-details
										class="fontsize_13_checkbox mt-0 mr-3"
										v-model="check.checked"
										@change="e => checkSeries2(e, idx)"
									>
										<template v-slot:label>
											<span :style="{ color: check.color }">{{ check.value }}</span>
										</template>
									</v-checkbox>
								</div>
							</v-layout>

							<v-layout row wrap style="height: 90%; flex-flow: nowrap">
								<!-- 커스텀 플로팅 바 start -->
								<div class="mr_big_bar" style="width: 18%; flex: none;">
									<div class="mr_bar_container">
										<div class="mr_bar_outer" v-for="item in rangeBarData" :key="item.id">
											<div
												class="mr_bar_inner"
												:style="{
													// 값이 없으면 투명
													backgroundColor: item.value <= 0 ? 'transparent' : item.color,
													width: getPercent(item.value, rangeBarData) + '%',
												}"
											>
												<div class="mr_bar_inner_txt_left">
													{{ item.value }}
												</div>
											</div>
											<div class="mr_bar_inner_txt_right">
												{{ getPercent(item.value, rangeBarData) + '%' }}
											</div>
										</div>
									</div>
								</div>
								<!-- 커스텀 바 end -->
								<div class="mr_line_container mr_scroll">
									<apexchart
										type="line"
										:options="line.chartOptions"
										:series="line.series"
										ref="lineChart"
										height="210px"
										:style="
											` width: ${line.chartOptions.xaxis.categories.length * 120 + 10}px;
                  height: 90%;`
										"
									></apexchart>
								</div>
							</v-layout>
						</v-layout>
					</v-layout>
				</v-layout>
			</v-flex>
		</v-layout>
		<!-- --- 데이터 테이블 -------- end -->
		<sweetAlert :dialog="sweetDialog" @click="clickSave()" />
		<sweetAlert :dialog="sweetInfo" />
	</div>
</template>

<script>
import { selectBox, DatepickerDialog, sweetAlert } from '@/components/index.js'
import VueApexCharts from 'vue-apexcharts'
export default {
	components: {
		selectBox,
		DatepickerDialog,
		sweetAlert,
		apexchart: VueApexCharts,
	},
	props: {
		nowTabs: Number,
		tabIdx: Number,
	},
	watch: {
		// nowTabs: {
		// 	deep: true,
		// 	async handler() {
		// 		if (this.nowTabs === this.tabIdx) {
		// 			console.log('여기임')
		// 		}
		// 	},
		// },
		chartOptions: {
			deep: true,
			handler(newOptions) {
				this.$refs.columnChart.updateOptions(newOptions, false, true)
			},
		},
	},
	mounted() {
		this.init()
		this.originColumnOptions = this.column.chartOptions
	},

	data() {
		return {
			allData: {},
			// 테이블 데이터
			counselor: [
				{ text: '총괄', value: '0' },
				{ text: '본부', value: '0' },
				{ text: '팀', value: '0' },
				{ text: '상담사', value: '0' },
				{ text: '로그인', value: '0' },
				{ text: '미확인', value: '0' },
			],
			call: [
				{ text: '배분수량', value: '0' },
				{ text: '처리', value: '0' },
				{ text: '미처리', value: '0' },
				{ text: '성공', value: '0' },
				{ text: '예약', value: '0' },
				{ text: '보류', value: '0' },
				{ text: '거부', value: '0' },
			],
			performance: [
				{ text: '배분수량', value: '0' },
				{ text: '통화성공', value: '0' },
				{ text: '방문예약', value: '0' },
				{ text: '상담완료', value: '0' },
				{ text: '계약가망', value: '0' },
				{ text: '가계약', value: '0' },
				{ text: '계약확인', value: '0' },
			],

			checkBoxList: [
				{ value: '통화성공', color: '#99D8E8', checked: true },
				{ value: '방문예약', color: '#5B99B1', checked: true },
				{ value: '상담완료', color: '#E2C3F7', checked: true },
				{ value: '계약가망', color: '#4EBCFE', checked: true },
				{ value: '가계약', color: '#4D7DE0', checked: true },
				{ value: '계약확인', color: '#974AFE', checked: true },
			],
			checkBoxList2: [
				{ value: '통화성공', color: '#99D8E8', checked: true },
				{ value: '방문예약', color: '#5B99B1', checked: true },
				{ value: '상담완료', color: '#E2C3F7', checked: true },
				{ value: '계약가망', color: '#4EBCFE', checked: true },
				{ value: '가계약', color: '#4D7DE0', checked: true },
				{ value: '계약확인', color: '#974AFE', checked: true },
			],

			color_data: [
				{ text: '성공', color: '#7ACCFE' },
				{ text: '예약', color: '#72B074' },
				{ text: '보류', color: '#FCBF78' },
				{ text: '거부', color: '#AAABAC' },
			],

			// 통화 처리 현황 바 데이터
			callBarData: [
				{ text: '성공', value: 0, percent: 0, color: '#06A2FF' },
				{ text: '예약', value: 0, percent: 0, color: '#127B12' },
				{ text: '보류', value: 0, percent: 0, color: '#FF9419' },
				{ text: '거부', value: 0, percent: 0, color: '#727272' },
			],
			// 성공건에 대한 고객, 상담처리 고객 호응도 바 데이터
			twoBarsData: [
				{
					id: 1,
					title: '통화 상담 고객 호응도',
					value: [
						{ grade: 'S', value: 0, percent: 0, color: '#AAE3E2' },
						{ grade: 'A', value: 0, percent: 0, color: '#D9ACF5' },
						{ grade: 'B', value: 0, percent: 0, color: '#FFCEFE' },
						{ grade: 'C', value: 0, percent: 0, color: '#FDEBED' },
						{ grade: 'D', value: 0, percent: 0, color: '#737373' },
					],
					chartOptions: null,
				},
				{
					id: 2,
					title: '방문 상담 고객 호응도',
					value: [
						{ grade: 'S', value: 0, percent: 0, color: '#AAE3E2' },
						{ grade: 'A', value: 0, percent: 0, color: '#D9ACF5' },
						{ grade: 'B', value: 0, percent: 0, color: '#FFCEFE' },
						{ grade: 'C', value: 0, percent: 0, color: '#FDEBED' },
						{ grade: 'D', value: 0, percent: 0, color: '#737373' },
					],
					chartOptions: null,
				},
			],

			// 기간별 마케팅 현황 바 데이터
			rangeBarData: [
				{ text: '통화성공', value: 0, percent: 0, color: '#51BEDA' },
				{ text: '방문예약', value: 0, percent: 0, color: '#187092' },
				{ text: '상담완료', value: 0, percent: 0, color: '#D9ACF5' },
				{ text: '계약가망', value: 0, percent: 0, color: '#06A2FF' },
				{ text: '가계약', value: 0, percent: 0, color: '#0449D5' },
				{ text: '계약 확인', value: 0, percent: 0, color: '#6E00FF' },
			],
			column_data: [
				// 1총괄
				{
					id: 1,
					name: '1총괄',
					hqList: [
						{
							id: 20,
							name: '1본부',
							teamList: [
								{ id: 30, title: '1팀', value: [100, 100, 100, 100, 100, 100] },
								{ id: 31, title: '2팀', value: [500, 400, 400, 300, 200, 100] },
								{ id: 31, title: '2팀', value: [500, 400, 400, 300, 200, 100] },
								{ id: 31, title: '2팀', value: [500, 400, 400, 300, 200, 100] },
							],
						},
					],
				},
			],
			origin_column_data: [],

			// 그래프 데이터들
			// 작은 도넛 그래프
			small_donut: {
				series: [0, 0],
				chartOptions: {
					chart: {
						type: 'donut',
						legend: 'bottom',
						width: 190,
						height: 190,
					},
					labels: ['처리', '미처리'],
					colors: ['#00E0EB', '#EDA75A'],
					plotOptions: {
						pie: {
							expandOnClick: false,
							distributed: true,
							donut: {
								// 라벨
								labels: {
									show: true,
									name: {
										show: true,
										fontSize: '22px',
										fontFamily: 'Helvetica, Arial, sans-serif',
										fontWeight: 600,
										color: '#373d3f',
										offsetY: -10,
										formatter: function(val) {
											return val
										},
									},
									value: {
										show: true,
										fontSize: '20px',
										fontFamily: 'Helvetica, Arial, sans-sesrif',
										fontWeight: 700,
										color: '#23318A',
										offsetY: -7,
										formatter: function(val) {
											return val
										},
									},
									total: {
										show: true,
										showAlways: true,
										label: '',
										fontSize: '15px',
										fontFamily: 'Helvetica, Arial, sans-serif',
										// fontWeight: 600,
										color: '#373d3f',
										formatter: function(w) {
											return w.globals.seriesTotals.reduce((a, b) => Math.floor(a + b), 0)
										},
									},
								},
							},
						},
					},
					states: {
						normal: {
							filter: {
								type: 'none',
								value: 0,
							},
						},
						hover: {
							filter: {
								type: 'none',
								value: 0,
							},
						},
					},

					dataLabels: {
						enabled: true,
						enabledOnSeries: undefined,
						style: {
							// fontSize: '16px',
							fontFamily: 'MalgunGothic',
							colors: ['#000000'],
						},
						formatter: function(
							value,
							{
								seriesIndex,
								dataPointIndex = '', // eslint-disable-line no-unused-vars,
								w,
							},
						) {
							return w.config.series[seriesIndex] === 0.1 ? '' : `${w.config.labels[seriesIndex]} ${w.config.series[seriesIndex]}`
						},

						dropShadow: {
							enabled: false,
						},
					},
					tooltip: {
						enabled: true,
					},
					legend: {
						show: false, // 범례 숨기기
					},
				},
			},
			// 큰 도넛 그래프
			big_donut: {
				series: [4.8, 10.3, 20.7, 27.6, 36.6],
				chartOptions: {
					chart: {
						type: 'donut',
						legend: 'bottom',
						width: 210,
						height: 248,
					},

					labels: ['S', 'A', 'B', 'C', 'D'],
					plotOptions: {
						pie: {
							customScale: 0.8,
							expandOnClick: true,

							//  (도넛 안 데이터)
							dataLabels: {
								enabled: true,
								// offset: 38,
								minAngleToShowLabel: 0,
							},

							// 도넛 세부 속성
							donut: {
								// size: '50%', // 가운데 빈 공간 크기
								// 라벨
								labels: {
									show: true,
									// 원안 위 텍스트
									name: {
										show: true,
										fontSize: '22px',
										fontFamily: 'Helvetica, Arial, sans-serif',
										fontWeight: 600,
										color: '#373d3f',
										offsetY: -10,
										formatter: function() {
											return ''
										},
									},
									// 원안 아래 텍스트
									value: {
										show: true,
										fontSize: '20px',
										fontFamily: 'Helvetica, Arial, sans-serif',
										fontWeight: 600,
										color: '#373d3f',
										offsetY: -8,
										formatter: function(val) {
											return val
										},
									},
									total: {
										show: true,
										showAlways: true,
										label: 'Total',
										fontSize: '15px',
										fontFamily: 'Helvetica, Arial, sans-serif',

										color: '#373d3f',
										formatter: function(w) {
											return w.globals.seriesTotals.reduce((a, b) => Math.floor(a + b), 0)
										},
									},
								},
							},
						},
					},
					states: {
						normal: {
							filter: {
								type: 'none',
								value: 0,
							},
						},
						hover: {
							filter: {
								type: 'none',
								value: 0,
							},
						},
					},
					dataLabels: {
						enabled: true,
						enabledOnSeries: undefined,
						style: {
							fontSize: '17px',
						},
						formatter: function(
							value,
							{
								seriesIndex,
								dataPointIndex = '', // eslint-disable-line no-unused-vars,
								w,
							},
						) {
							return w.config.series[seriesIndex] === 0.1 ? '' : `${w.config.labels[seriesIndex]} ${Math.floor(value)}%`
						},
					},
					// 색상 (S ~ D 순)
					colors: ['#AAE3E2', '#D9ACF5', '#FFCEFE', '#FDEBED', '#737373'],

					legend: {
						show: false, // 범례 숨기기
					},
				},
			},
			// 바 그래프 (큰)
			big_bar: {
				series: [
					{
						name: 'data',
						data: [0, 0, 0, 0],
					},
				],
				chartOptions: {
					chart: {
						type: 'bar',
						height: 350,
						// 옵션 툴바를 숨깁니다.
						toolbar: {
							show: false,
						},
					},
					plotOptions: {
						bar: {
							borderRadius: 4,
							borderRadiusApplication: 'end',
							horizontal: true,
							distributed: true, // 여러 색상 사용 가능 옵션
						},
					},
					colors: ['#06A2FF', '#127B12', '#FF9419', '#727272'], // 막대에 색상 직접 설정
					dataLabels: {
						enabled: false, // 데이터 라벨 숨기기
					},
					legend: {
						show: true, // 범례 숨기기
						position: 'top',
						horizontalAlign: 'right',

						floating: false,
					},
					// x축 설정
					xaxis: {
						categories: ['성공', '예약', '보류', '거부'],
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
						},
						axisBorder: {
							show: false, // x축 선 숨기기
						},
						axisTicks: {
							show: false, // x축 눈금 선 숨기기
						},
					},
					// y축 설정
					yaxis: {
						categories: [''],
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
						},
						axisBorder: {
							show: false, // y축 선 숨기기
						},
						axisTicks: {
							show: false, // y축 눈금 선 숨기기
						},
					},
					grid: {
						show: false, // 그리드 선 숨기기
					},
				},
			},
			// 바 그래프
			bar: {
				series: [
					{
						data: [0, 0, 0, 0],
					},
				],
				chartOptions: {
					chart: {
						type: 'bar',
						height: 350,
						// 옵션 툴바를 숨깁니다.
						toolbar: {
							show: false,
						},
					},
					plotOptions: {
						bar: {
							borderRadius: 4,
							borderRadiusApplication: 'end',
							horizontal: true,
							distributed: true,
						},
					},
					colors: ['#AAE3E2', '#D9ACF5', '#FFCEFE', '#FDEBED', '#737373'],
					dataLabels: {
						enabled: true, // 데이터 라벨 숨기기
						style: {
							fontSize: '12px',
						},
					},
					// 캡션
					legend: {
						show: false, // 범례 숨기기
					},
					// x축 설정
					xaxis: {
						categories: ['S', 'A', 'B', 'C', 'D'],
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
							style: {
								colors: ['#06A2FF'], // x축 레이블 색상 지정
								fontSize: '14px', // x축 레이블 폰트 사이즈
							},
						},
						axisBorder: {
							show: false, // x축 선 숨기기
						},
						axisTicks: {
							show: false, // x축 눈금 선 숨기기
						},
					},
					// y축 설정
					yaxis: {
						categories: [''],
						labels: {
							show: true, // x축 카테고리 라벨 숨기기
							style: {
								// colors: ['#06A2FF'], // x축 레이블 색상 지정
								// fontSize: '14px', // x축 레이블 폰트 사이즈
								fontWeight: 700,
							},
						},
						axisBorder: {
							show: false, // y축 선 숨기기
						},
						axisTicks: {
							show: false, // x축 눈금 선 숨기기
						},
					},
					grid: {
						show: false, // 그리드 선 숨기기
					},
				},
			},
			// 컬럼차트
			column: {
				series: [
					{
						name: '통화성공',
						data: [0],
					},
					{
						name: '방문예약',
						data: [0],
					},
					{
						name: '상담완료',
						data: [0],
					},
					{
						name: '계약가망',
						data: [0],
					},
					{
						name: '가계약',
						data: [0],
					},
					{
						name: '계약확인',
						data: [0],
					},
				],
				chartOptions: {
					chart: {
						type: 'bar',

						toolbar: {
							show: false,
						},
						zoom: {
							enabled: false,
						},
					},

					plotOptions: {
						bar: {
							// borderRadius: '2',
							// borderRadiusApplication: 'end', // 테두리 속성 끝에만 적용
							distributed: false, // 개별 데이터 포인트에 색상 적용
							// columnWidth: '50%',
							// barHeight: '10%',
						},
					},

					colors: ['#99D8E8', '#5B99B1', '#E2C3F7', '#4EBCFE', '#4D7DE0', '#974AFE'],
					dataLabels: {
						enabled: false, // 데이터 라벨 비활성화- 막대안의 글자
					},
					xaxis: {
						type: 'category',
						categories: ['', '', '', '', '', ''],
						labels: {
							// 개별 막대 아래 글자
							formatter: function() {
								return ''
							},
							// 그룹
							show: true,
						},
						group: {},

						axisBorder: {
							show: false, // x축 선 숨기기
						},
						axisTicks: {
							show: false, // x축 눈금 선 숨기기
						},
					},
					// y축 설정
					yaxis: {
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
						},
						axisBorder: {
							show: false, // x축 선 숨기기
						},
						axisTicks: {
							show: false, // x축 눈금 선 숨기기
						},
					},

					// 가로축 없애기
					grid: {
						show: true,
						borderColor: '#90A4AE',
						strokeDashArray: 0,
						position: 'back',
						xaxis: {
							lines: {
								show: false,
							},
						},
						yaxis: {
							lines: {
								show: false,
							},
						},
					},

					title: {
						text: '',
					},
					tooltip: {
						y: {
							formatter: function(value) {
								return Math.round(value) // 소수점을 반올림하여 정수로 표시
							},
						},
					},
					legend: {
						show: false,
					},
					stroke: {
						colors: ['transparent'],
						width: 4,
					},
				},
			},

			// 바 그래프 (큰)
			small_bar: {
				series: [
					{
						data: [0, 0, 0, 0, 0],
					},
				],
				chartOptions: {
					chart: {
						type: 'bar',
						height: 350,
						// 옵션 툴바를 숨깁니다.
						toolbar: {
							show: false,
						},
					},
					plotOptions: {
						bar: {
							borderRadius: 4,
							borderRadiusApplication: 'end',
							distributed: true, // 여러 색상 사용 가능 옵션
							horizontal: true,
							colors: {
								backgroundBarColors: ['#f4f4f4'], // 막대의 배경 색상
								backgroundBarOpacity: 1, // 배경 색상의 불투명도
								backgroundBarRadius: 4, // 배경 색상의 둥근 모서리
							},
						},
					},
					colors: ['#FF4560', '#00E396', '#008FFB', '#FF9800', '#775DD0'], // 막대에 색상 직접 설정
					dataLabels: {
						enabled: true, // 데이터 라벨 숨기기
					},

					// x축 설정
					xaxis: {
						categories: [''],
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
						},
					},
					// y축 설정
					yaxis: {
						categories: [''],
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
						},
					},
				},
			},
			// 라인 그래프
			line: {
				series: [
					{
						name: '통화성공',
						data: [0],
					},
					{
						name: '방문예약',
						data: [0],
					},
					{
						name: '상담완료',
						data: [0],
					},
					{
						name: '계약가망',
						data: [0],
					},
					{
						name: '가계약',
						data: [0],
					},
					{
						name: '계약 확인',
						data: [0],
					},
				],
				chartOptions: {
					chart: {
						background: 'transparent',
						height: 350,
						type: 'line',
						// 하단 가로선 배경
						dropShadow: {
							enabled: false,
							color: '#000',
							top: 18,
							left: 7,
							blur: 10,
							opacity: 0.2,
						},
						zoom: {
							enabled: false,
						},
						toolbar: {
							show: false,
						},
					},

					colors: ['#99D8E8', '#5B99B1', '#E2C3F7', '#4EBCFE', '#4D7DE0', '#974AFE'],
					dataLabels: {
						enabled: true,
						formatter: function(val, opts) {
							// 첫 번째 데이터 포인트에서만 레이블을 표시합니다.
							return opts.dataPointIndex === 0 ? val : undefined
						},

						style: {
							fontSize: '12px',
							colors: ['#99D8E8', '#5B99B1', '#E2C3F7', '#4EBCFE', '#4D7DE0', '#974AFE'],
						},
						background: {
							enabled: true,
							foreColor: '#fff',
							padding: 6,
							borderRadius: 2,
							borderWidth: 1,
							borderColor: ['#99D8E8', '#5B99B1', '#E2C3F7', '#4EBCFE', '#4D7DE0', '#974AFE'],
							opacity: 0.9,
							dropShadow: {
								enabled: false,
								top: 1,
								left: 1,
								blur: 1,
								color: '#000',
								opacity: 0.45,
							},
						},

						offsetY: 0,
						dropShadow: {
							enabled: true,
							top: 1,
							left: 1,
							blur: 1,
							opacity: 0.75,
						},
					},
					stroke: {
						curve: 'straight',
					},

					title: {
						text: '',
						align: 'right',
					},
					// 캡션 옵션
					legend: {
						show: false,
						position: 'top',
						horizontalAlign: 'right',
						floating: true,
						// offsetY: -25,
						// offsetX: -30,
					},
					grid: {
						show: false,
						borderColor: 'transparent',
						row: {
							colors: ['transparent'], // takes an array which will be repeated on columns
							opacity: 0.5,
						},
					},

					markers: {
						size: 4,
						// colors: ['#99D8E8', '#5B99B1', '#E2C3F7', '#4EBCFE', '#4D7DE0', '#974AFE'],
						strokeColors: ['#99D8E8', '#5B99B1', '#E2C3F7', '#4EBCFE', '#4D7DE0', '#974AFE'], // Marker border color
						strokeWidth: 2,
						strokeOpacity: 0.9,
						strokeDashArray: 0,
						fillOpacity: 1,
						discrete: [],
						shape: 'circle',
						offsetX: 0,
						offsetY: 0,
						onClick: undefined,
						onDblClick: undefined,
						showNullDataPoints: true,
						hover: {
							size: undefined,
							sizeOffset: 3,
						},
					},

					tooltip: {
						y: {
							formatter: function(value) {
								return Math.round(value) // 소수점을 반올림하여 정수로 표시
							},
						},
					},

					xaxis: {
						labels: {
							// show: false, // x축 카테고리 라벨 숨기기
							offsetX: 1,
						},
						axisBorder: {
							show: false, // x축 선 숨기기
							offsetX: 1,
						},
						axisTicks: {
							// show: false, // x축 눈금 선 숨기기
							offsetX: 1,
						},
						categories: [],
						title: {
							offsetX: 1,
							// text: 'Month',
						},
						tooltip: {
							enabled: false,
						},
					},
					yaxis: {
						labels: {
							show: false, // x축 카테고리 라벨 숨기기
						},
						axisBorder: {
							// show: false, // x축 선 숨기기
						},
						axisTicks: {
							// show: false, // x축 눈금 선 숨기기
						},
						title: {
							// text: 'Temperature',
						},
						// y축 최소/ 최대 지점
						min: 0,
						// max: ,
					},
				},
			},
			// --- 데이터 테이블 데이터 --

			surveySel: {
				// 사업지 선택 셀렉트 박스
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
			},

			surveySel_campaign: {
				// 캠페인 선택 셀렉트 박스
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
			},

			// 날짜/검색 데이터
			searchsel: {
				// 날짜 선택 셀렉트 박스 - 오늘 , 이번주 , 이번달
				value: '오늘',
				errorMessage: '',
				hideDetail: true,
				items: ['오늘', '이번 주', '이번 달'],
				outlined: true,
			},
			// 마케팅 현광 셀렉트
			datesel: {
				// 마케팅 현광 셀렉트 박스 - 오늘 , 이번주 , 이번달
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: ['전체', '성공', '예약', '보류', '거부'],
				outlined: true,
			},
			// 총괄 셀렉트
			glsel: {
				value: { name: '전체' },
				errorMessage: '',
				hideDetail: true,
				items: [{ name: '전체' }],
				outlined: true,
				itemText: 'name',
				returnObject: true,
				label: '',
			},
			// 본부 셀렉트
			hqsel: {
				value: {},
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				itemText: 'name',
				returnObject: true,
				label: '',
			},
			ready: false,
			// 팀 셀렉트
			teamsel: {
				value: {},
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				itemText: 'title',
				returnObject: true,
				label: '',
			},

			termStartpicker: {
				// datePicker
				date: this.$moment()
					.subtract(6, 'days')
					.format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			termEndpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},
			first: true,
			chartKey: null,
			sweetDialog: {
				// 계약자 업데이트 확인 팝업
				open: false,
				title: '계약자 업데이트',
				content: `캠페인 고객 중 계약자를
'계약확인' 상태로 업데이트 합니다.`,
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
				saveBtnText: '확인',
				modalIcon: 'success',
			},
			sweetInfo: {
				// 완료/실패 팝업
				open: false,
				title: '',
				content: ``,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
		}
	},
	async created() {
		// 원본 복사해두기
		this.origin_column_data = JSON.parse(JSON.stringify(this.column_data))
		await this.bizTitle()
		await this.search_biz()

		this.first = false
	},
	computed: {},
	methods: {
		ChangeGl() {
			if (this.glsel.value.name === '전체') {
				this.hqsel.items = []
				this.hqsel.label = ''
				this.teamsel.items = []
				this.teamsel.label = ''
				this.column_data = JSON.parse(JSON.stringify(this.glsel.items)).splice(1)
				this.column.series = this.allData.teamMarketingChart
			} else {
				this.hqsel.items = [...[{ name: '전체' }], ...this.glsel.value.hqList]
				this.hqsel.value = { name: '전체' }
				this.hqsel.label = '본부'
				this.column_data = [this.glsel.value]
				this.column.series = this.customSeries([this.glsel.value])
			}
		},
		ChangeHq() {
			if (this.hqsel.value.name === '전체') {
				this.teamsel.items = []
				this.teamsel.label = ''
				let all_data = JSON.parse(JSON.stringify(this.glsel.items)).splice(1)
				let emty_li = []
				// title 항목 수정
				for (let i = 0; i < all_data.length; i++) {
					if (all_data[i].id === this.glsel.value.id) {
						emty_li.push(all_data[i])
					}
				}

				this.column_data = emty_li
				this.column.series = this.customSeries(emty_li)
			} else {
				this.teamsel.items = [...[{ title: '전체' }], ...this.hqsel.value.teamList]
				this.teamsel.value = { title: '전체' }
				this.teamsel.label = '팀'
				// title 항목 수정
				let all_data = JSON.parse(JSON.stringify(this.glsel.items)).splice(1)
				let emty_li = []

				for (let i = 0; i < all_data.length; i++) {
					let emti_li2 = []
					for (let j = 0; j < all_data[i].hqList.length; j++) {
						if (all_data[i].hqList[j].id === this.hqsel.value.id) {
							emti_li2.push(all_data[i].hqList[j])
						}
					}
					if (all_data[i].id === this.glsel.value.id) {
						all_data[i].hqList = emti_li2
						emty_li.push(all_data[i])
					}
				}
				this.column_data = emty_li
				this.column.series = this.customSeries(emty_li)
			}
		},
		ChangeTeam() {
			if (this.teamsel.value.title === '전체') {
				let all_data = JSON.parse(JSON.stringify(this.glsel.items)).splice(1)
				let emty_li = []
				// title 항목 수정
				for (let i = 0; i < all_data.length; i++) {
					let emti_li2 = []
					for (let j = 0; j < all_data[i].hqList.length; j++) {
						if (all_data[i].hqList[j].id === this.hqsel.value.id) {
							emti_li2.push(all_data[i].hqList[j])
						}
					}
					if (all_data[i].id === this.glsel.value.id) {
						all_data[i].hqList = emti_li2
						emty_li.push(all_data[i])
					}
				}
				this.column_data = emty_li
				this.column.series = this.customSeries(emty_li)
			} else {
				// title 항목 수정
				let all_data = JSON.parse(JSON.stringify(this.glsel.items)).splice(1)
				let emty_li = []

				for (let i = 0; i < all_data.length; i++) {
					let emti_li2 = []
					for (let j = 0; j < all_data[i].hqList.length; j++) {
						let emti_li3 = []

						for (let k = 0; k < all_data[i].hqList[j].teamList.length; k++) {
							if (all_data[i].hqList[j].teamList[k].id === this.teamsel.value.id) {
								emti_li3.push(all_data[i].hqList[j].teamList[k])
							}
						}
						if (all_data[i].hqList[j].id === this.hqsel.value.id) {
							all_data[i].hqList[j].teamList = emti_li3
							emti_li2.push(all_data[i].hqList[j])
						}
					}
					if (all_data[i].id === this.glsel.value.id) {
						all_data[i].hqList = emti_li2
						emty_li.push(all_data[i])
					}
				}
				this.column_data = emty_li
				this.column.series = this.customSeries(emty_li)
			}
		},
		async bizTitle() {
			this.$store.state.loading = true
			await this.$store.dispatch('bizTitle').then(async resData => {
				if (resData.data.bizTitle.businesses.length > 0) {
					this.surveySel.items = resData.data.bizTitle.businesses
					this.surveySel.value = resData.data.bizTitle.businesses[0]

					await this.getTableData()

					this.$store.state.loading = false
				} else this.$store.state.loading = false
			})
		},

		async search_biz() {
			this.$store.state.loading = true

			const variable = {
				businessId: String(this.surveySel.value.id),
			}
			await this.$store.dispatch('campaignsTitle', variable).then(async res => {
				this.surveySel_campaign.items = res.data.campaigns
				// console.log(res.data.campaigns)

				if (res.data.campaigns.length > 0) {
					this.surveySel_campaign.value = res.data.campaigns[0]
				} else {
					this.surveySel_campaign.value = null
				}
				await this.getTableData()
			})
			this.$store.state.loading = false
		},

		async search_campaign() {
			await this.getTableData()
		},
		async getTableData() {
			if (this.first) {
				return
			}

			this.checkSelectInit()
			this.$store.state.loading = true

			const { id, businessId } = this.surveySel_campaign.value || ['', '']

			const data = {
				campaignId: id,
				businessId: businessId,
				startDate: this.termStartpicker.date,
				endDate: this.termEndpicker.date,
			}

			await this.$store
				.dispatch('marketingReport', data)
				.then(async res => {
					const { today, callSuccessGrade, meetingDoneGrade, callCurrent, rangeMarketing } = res.data.marketingReport.response

					// 기존 firstCall로직 시작
					// - 컬럼 데이터 적용
					this.allData = res.data.marketingReport.response
					let marketData = res.data.marketingReport.response.teamMarketingData
					let marketData_li = []
					for (let i = 0; i < marketData.length; i++) {
						let marketData_hq_li = []
						for (let j = 0; j < marketData[i].hq.length; j++) {
							if (marketData[i].hq[j].teamExist) {
								marketData[i].hq[j].name = marketData[i].hq[j].title
								marketData[i].hq[j].teamList = marketData[i].hq[j].team
								marketData_hq_li.push(marketData[i].hq[j])
							}
						}
						if (marketData[i].teamExist) {
							marketData[i].name = marketData[i].title
							marketData[i].hqList = marketData_hq_li
							marketData_li.push(marketData[i])
						}
					}

					let gl_sel_li = [{ name: '전체' }]
					this.glsel.items = [...gl_sel_li, ...marketData_li]
					this.glsel.value = '전체'
					this.glsel.label = '총괄'
					this.column_data = marketData_li
					this.column.series = res.data.marketingReport.response.teamMarketingChart

					// 팀 데이터가 1개 일시 라벨링 위치 수정
					if (this.column.series[0].data.length === 1) {
						this.column.chartOptions = {
							...this.column.chartOptions,
							tooltip: {
								...this.column.chartOptions.tooltip,
								fixed: {
									enabled: true,
									position: 'topLeft',
									offsetX: 30,
									offsetY: 40,
								},
							},
						}
						this.chartKey = `chart_${Date.now()}` // key를 현재 시간으로 변경하여 다시 렌더링
					} else {
						// 1개가 아니면 기존값 적용
						this.column.chartOptions = {
							...this.originColumnOptions,
						}
						this.chartKey = `chart_${Date.now()}` // key를 현재 시간으로 변경하여 다시 렌더링
					}

					// 기존 firstCall 로직 끝

					// 성과현황 & 통화 처리 현황 적용
					//  -좌측
					const performKeys = Object.keys(today.performance)
					this.performance = this.performance.map((v, i) => ({
						...v,
						value: today.performance[performKeys[i]],
					}))

					// -가운데
					const callKeys = Object.keys(today.call)
					this.call = this.call.map((v, i) => ({
						...v,
						value: today.call[callKeys[i]],
					}))

					// - 맨 우측
					const counselKeys = Object.keys(today.counselor)
					this.counselor = this.counselor.map((v, i) => ({
						...v,
						value: today.counselor[counselKeys[i]],
					}))

					// 통화 처리 현황 적용
					// - 도넛 적용
					this.small_donut.series = callCurrent.chartData
					this.small_donut.chartOptions = { ...this.small_donut.chartOptions, colors: ['#00E0EB', '#EDA75A'], tooltip: { enabled: true } }

					// 총 데이터가 0이면,
					if (Number(callCurrent.all) === 0) {
						this.small_donut.series = [0.1]
						this.small_donut.chartOptions = { ...this.small_donut.chartOptions, colors: ['#DEDEDE'], tooltip: { enabled: false } }
					}
					// - 바 적용
					const arr = [Number(callCurrent.success), Number(callCurrent.reserve), Number(callCurrent.absence), Number(callCurrent.reject)]
					this.callBarData = this.callBarData.map((v, i) => ({
						...v,
						value: arr[i],
					}))

					// 성공건에 대한 고객, 상담처리 고객 호응도

					this.twoBarsData[0].value = this.twoBarsData[0].value.map((v, i) => ({
						...v,
						value: callSuccessGrade.chartData[i],
					}))

					this.twoBarsData[1].value = this.twoBarsData[1].value.map((v, i) => ({
						...v,
						value: meetingDoneGrade.chartData[i],
					}))

					this.twoBarsData[0].chartOptions = {
						...this.big_donut.chartOptions,
						colors: ['#AAE3E2', '#D9ACF5', '#FFCEFE', '#FDEBED', '#737373'],
						tooltip: { enabled: true },
					}
					this.twoBarsData[1].chartOptions = {
						...this.big_donut.chartOptions,
						colors: ['#AAE3E2', '#D9ACF5', '#FFCEFE', '#FDEBED', '#737373'],
						tooltip: { enabled: true },
					}

					// 총 데이터가 0이면,
					if (Number(callSuccessGrade.gradeTotal) === 0) {
						this.twoBarsData[0].value[0].value = 0.1
						this.twoBarsData[0].chartOptions = {
							...this.twoBarsData[0].chartOptions,
							colors: ['#DEDEDE'],
							tooltip: { enabled: false },
						}
					}
					// 총 데이터가 0이면,
					if (Number(meetingDoneGrade.gradeTotal) === 0) {
						this.twoBarsData[1].value[0].value = 0.1
						this.twoBarsData[1].chartOptions = {
							...this.twoBarsData[1].chartOptions,
							colors: ['#DEDEDE'],
							tooltip: { enabled: false },
						}
					}

					// 기간별 마케팅 현황 적용
					// - 바 적용
					const rangeKeys = Object.keys(rangeMarketing)
					this.rangeBarData = this.rangeBarData.map((v, i) => ({ ...v, value: rangeMarketing[rangeKeys[i]] }))

					// - 라인 그래프 적용
					// -- 숫자 데이터
					this.line.series = rangeMarketing.rangeData || []

					//  -- 연도 데이터
					this.line.chartOptions.xaxis.categories = rangeMarketing.range || []
					const chart = this.$refs.lineChart
					chart.updateOptions({
						xaxis: {
							labels: {},
							axisBorder: {
								show: false, // x축 선 숨기기
							},
							axisTicks: {},
							categories: rangeMarketing.range || [],
							title: {},
						},
					})
					this.$store.state.loading = false
				})
				.catch(() => {
					this.init()

					this.$store.state.loading = false
				})

			this.$store.state.loading = false
		},

		async setdate() {
			let today = new Date()
			let before = new Date(today.setDate(today.getDate() - 7))
			let after = new Date(today.setDate(today.getDate() + 7))
			this.termStartpicker.date = this.$moment(before).format('YYYY-MM-DD')
			this.termEndpicker.date = this.$moment(after).format('YYYY-MM-DD')
		},
		selectDays(date) {
			if (date === '오늘') {
				this.termStartpicker.date = this.$moment().format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment().format('YYYY-MM-DD')
			} else if (date === '이번 주') {
				this.termStartpicker.date = this.$moment().format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.add(7, 'd')
					.format('YYYY-MM-DD')
			} else if (date === '이번 달') {
				this.termStartpicker.date = this.$moment()
					.startOf('month')
					.format('YYYY-MM-DD')
				this.termEndpicker.date = this.$moment()
					.endOf('month')
					.format('YYYY-MM-DD')
			}
		},

		termCustomer(val) {
			let start = this.$moment(this.termStartpicker.date).format('YYMMDD')
			let startDate = new Date(this.termStartpicker.date)
			let end = new Date(startDate.setDate(startDate.getDate() + 240))
			let endDate = this.$moment(end).format('YYMMDD')
			val = this.$moment(val).format('YYMMDD') < endDate && this.$moment(val).format('YYMMDD') >= start
			return val
		},

		checkSeries(idx) {
			const seriesName = this.checkBoxList[idx].value

			const chart = this.$refs.columnChart
			chart.toggleSeries(seriesName)
		},
		checkSeries2(event, idx) {
			const seriesName = this.checkBoxList2[idx].value

			const chart = this.$refs.lineChart

			chart.toggleSeries(seriesName)
		},

		customSeries(list) {
			list = list[0]
			let arr = [
				{
					name: '통화성공',
					data: [],
				},
				{
					name: '방문예약',
					data: [],
				},
				{
					name: '상담완료',
					data: [],
				},
				{
					name: '계약가망',
					data: [],
				},
				{
					name: '가계약',
					data: [],
				},
				{
					name: '계약확인',
					data: [],
				},
			]
			for (let i = 0; i < list.hqList.length; i++) {
				for (let j = 0; j < list.hqList[i].teamList.length; j++) {
					for (let k = 0; k < list.hqList[i].teamList[j].chart.length; k++) {
						switch (list.hqList[i].teamList[j].chart[k].name) {
							case '통화성공':
								arr[0].data.push(list.hqList[i].teamList[j].chart[k].data)
								break
							case '방문예약':
								arr[1].data.push(list.hqList[i].teamList[j].chart[k].data)
								break
							case '상담완료':
								arr[2].data.push(list.hqList[i].teamList[j].chart[k].data)
								break
							case '계약가망':
								arr[3].data.push(list.hqList[i].teamList[j].chart[k].data)
								break
							case '가계약':
								arr[4].data.push(list.hqList[i].teamList[j].chart[k].data)
								break
							case '계약확인':
								arr[5].data.push(list.hqList[i].teamList[j].chart[k].data)
								break
							default:
						}
					}
				}
			}
			console.log(arr)

			return arr
		},

		getSeries(value) {
			// value[0].data[0] = value[0].data[0] + 13
			// value[0].data[1] = value[0].data[1] + 13
			// value[1].data[0] = value[0].data[1] + 13
			// value[2].data[0] = value[0].data[1] + 13
			// value[3].data[0] = value[0].data[1] + 13
			// value[4].data[0] = value[0].data[1] + 13
			// value[5].data[0] = value[0].data[1] + 13
			return value
		},
		getHqLength(hq) {
			return hq.teamList.length
		},
		getGlLength(gl) {
			return gl.hqList.reduce((a, c) => a + c.teamList.length, 0)
		},
		// 초기화
		init() {
			// 윗 부분  박스들

			for (let i = 0; i < this.performance.length; i++) {
				this.performance[i].value = 0
			}

			for (let i = 0; i < this.counselor.length; i++) {
				this.counselor[i].value = 0
			}
			for (let i = 0; i < this.call.length; i++) {
				this.call[i].value = 0
			}

			// 작은 도넛 초기화
			for (let i = 0; i < this.callBarData.length; i++) {
				this.callBarData[i].value = 0
				this.callBarData[i].percent = 0
			}
			this.small_donut.series = [0.1]
			this.small_donut.chartOptions = { ...this.small_donut.chartOptions, colors: ['#DEDEDE'], tooltip: { enabled: false } }

			// 큰 도넛 초기화
			for (let i = 0; i < this.twoBarsData.length; i++) {
				for (let j = 0; j < this.twoBarsData[i].value.length; j++) {
					this.twoBarsData[i].value[j].value = 0
					this.twoBarsData[i].value[j].percent = 0
				}
			}
			this.twoBarsData[0].value[0].value = 0.1
			this.twoBarsData[1].value[0].value = 0.1
			this.twoBarsData[0].chartOptions = { ...this.big_donut.chartOptions, colors: ['#DEDEDE'], tooltip: { enabled: false } }
			this.twoBarsData[1].chartOptions = { ...this.big_donut.chartOptions, colors: ['#DEDEDE'], tooltip: { enabled: false } }

			// 라인 그래프 초기화
			for (let i = 0; i < this.rangeBarData.length; i++) {
				this.rangeBarData[i].value = 0
				this.rangeBarData[i].percent = 0
			}
			this.line.series = [
				{
					name: '통화성공',
					data: [],
				},
				{
					name: '방문예약',
					data: [],
				},
				{
					name: '상담완료',
					data: [],
				},
				{
					name: '계약가망',
					data: [],
				},
				{
					name: '가계약',
					data: [],
				},
				{
					name: '계약 확인',
					data: [],
				},
			]
			this.column.series = [
				{
					name: '통화성공',
					data: [],
				},
				{
					name: '방문예약',
					data: [],
				},
				{
					name: '상담완료',
					data: [],
				},
				{
					name: '계약가망',
					data: [],
				},
				{
					name: '가계약',
					data: [],
				},
				{
					name: '계약 확인',
					data: [],
				},
			]
			this.column_data = []

			this.checkSelectInit()
			this.ready = true
		},
		checkSelectInit() {
			// 체크박스 초기화
			this.checkBoxList = this.checkBoxList.map(v => ({
				...v,
				checked: true,
			}))
			this.checkBoxList2 = this.checkBoxList2.map(v => ({
				...v,
				checked: true,
			}))

			// 팀별 마케팅 셀렉트 초기화
			this.glsel.label = ''
			this.hqsel.label = ''
			this.teamsel.label = ''
			this.glsel.items = []
			this.hqsel.items = []
			this.teamsel.items = []
			this.glsel.value = ''
			this.hqsel.value = ''
			this.teamsel.value = ''
		},
		/** 평균값을 구하는 함수 x / y
		@param {String or Number} current 대상값
		@param {Array} arr value키를 가진 오브젝트들로 구성된 배열
		@author 임호진
		@returns 정수 숫자
		*/
		getPercent(current, arr) {
			if (!Array.isArray(arr)) return
			return Math.round((Number(current) / Number(arr.reduce((a, c) => a + Number(c.value), 0))) * 100) || 0
		},

		/**** 계약자 업데이트 버튼 클릭
캠페인, 프로젝트 벨리데이션 
 @author 전현균 
 */
		confirmUpdateClick() {
			const { id, businessId } = this.surveySel_campaign.value || ['', '']

			if (!id) {
				this.sweetInfo.title = '캠페인 미선택'
				this.sweetInfo.content = `캠페인을 선택해주세요.`
				this.sweetInfo.modalIcon = `info`
				this.sweetInfo.open = true
			} else if (!businessId) {
				this.sweetInfo.title = '프로젝트 미선택'
				this.sweetInfo.content = `프로젝트를 선택해주세요.`
				this.sweetInfo.modalIcon = `info`
				this.sweetInfo.open = true
			} else {
				this.sweetDialog.open = true
			}
		},

		/****계약자 업데이트 실행
0건 이상 업데이트 되는 경우 통계 데이터 다시 호출해서 최신화 
 @author 전현균 
 */
		async clickSave() {
			const { id, businessId } = this.surveySel_campaign.value || ['', '']

			let variable = {
				campaignId: String(id),
				businessId: String(businessId),
			}

			this.$store.state.loading = true

			this.sweetDialog.open = false

			await this.$store
				.dispatch('contractConfirmUpdate', variable)
				.then(async res => {
					const success_count = res.data.contractConfirmUpdate.response.success

					if (success_count > 0) {
						await this.getTableData()
					}

					this.sweetInfo.title = '업데이트 완료'
					this.sweetInfo.content = `${success_count}건의 계약자를 업데이트했습니다.`
					this.sweetInfo.modalIcon = `success`
					this.sweetInfo.open = true
					this.$store.state.loading = false
				})
				.catch(err => {
					console.log(err)

					this.sweetInfo.title = '네트워크 에러'
					this.sweetInfo.content = `네트워크 에러가 발생헀습니다.\n관리자에게 문의해주세요.`
					this.sweetInfo.modalIcon = `info`
					this.sweetInfo.open = true

					this.$store.state.loading = false
				})
		},
	},
}
</script>
<style lang="scss">
:root {
	/* 마케팅 통계관리 차트 간격 */
	--mr-gap: 6px; // 작은 간격
	--mr-big-gap: 6px; // 큰 간격
	--mr-width: 125px; // 팀 스틱 1개의 너비
}
.mr_whole_container {
	overflow-x: auto;
}

.mr_scroll {
	&::-webkit-scrollbar-thumb {
		background: #c2bcc2 !important; /* 스크롤바의 색상 */
		width: 90% !important; /* 스크롤바의 너비 */
		border-radius: 10px !important;
	}
	&::-webkit-scrollbar {
		width: 90% !important; /* 스크롤바의 너비 */
		height: 9.4px !important; /* 스크롤바의 높이 */
	}
	&::-webkit-scrollbar-track {
		/* background: #ccc; 스크롤바 뒷 배경 색상 */
		background: transparent;
	}
}

@media (max-width: 1263px) {
	.mr_whole_container {
		width: auto;
	}
}
@media (min-width: 1264px) {
	.mr_whole_container {
		width: calc(100vw - 275px);
	}
}

/* 그래프 스타일 */
.marketing_report_graph_container {
	width: calc(86vw - 37px);
	height: 100%;
	min-width: 1379px;

	align-items: center;
	padding: 12px 21px 9px 18px;
	overflow-x: auto;
	overflow-y: clip;
	background-color: #f5f5f5;
	border-radius: 9px;

	.mr_column_gl_container {
		margin-right: 20px !important;
		flex-flow: nowrap;
		width: 100%;
	}

	/* 1팀 뺴고 나머지는 세로 선 제거 */
	.mr_column_gl_container:not(:nth-child(2)) .mr_team_stick_container:nth-child(1)::before {
		display: none;
	}

	.mr_stick_container {
		display: flex;
		flex-direction: column;
		transform: translateY(-50px);

		.mr_team_stick_container {
			display: flex;

			/* 중간 선 */
			div:not(:last-child) {
				.mr_team_stick:last-child::after {
					content: '';
					position: absolute;

					right: -3.5px;
					bottom: 2px;

					width: 1px;
					height: 262px;
					background-color: #ccc; /* 테두리 색상 */
				}
			}

			&:nth-child(1)::before {
				content: '';
				position: absolute;

				left: 0px;
				bottom: 25px;
			}

			/* 팀 블록 */
			.mr_team_stick {
				width: var(--mr-width);
				border-radius: 3px;
				background-color: #ff9587;
				text-align: center;
				/* gap만큼 간격 */
				margin-right: var(--mr-gap);
				padding: 1px 5px;
				position: relative;
				color: #ffffff;
				/* 마지막 요소는 더 큰 간격 */
				&:last-child {
					margin-right: var(--mr-big-gap);
				}

				/* 팀 사이 가상 선(가장 짧은 선) */
				&:not(:last-child)::after {
					content: '';
					position: absolute;

					right: -1px;
					bottom: 25px;

					width: 1px; /* 추가적인 테두리 너비 */
					height: 250px;
					background-color: #ccc; /* 테두리 색상 */
				}
			}
		}

		.mr_hq_stick_container {
			display: flex;
			margin: 2px 0;
			/* 본부 블럭 */
			.mr_hq_stick {
				width: 62px;
				border-radius: 3px;
				text-align: center;
				background-color: #a7dfb4;
				margin-right: var(--mr-big-gap);
				padding: 1px 5px;
				color: #8d3b3b;
			}
		}
		.mr_gl_stick_container {
			display: flex;
			.mr_gl_stick {
				width: 62px;
				text-align: center;
				border-radius: 3px;
				background-color: #fedd8a;
				margin-right: var(--mr-big-gap);
				color: #000000;
				padding: 1px 5px;
			}
		}
	}
	.ellipsis-text {
		display: block;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.mr_column_gl_container > div:nth-child(1) {
		margin-left: -12px;
	}
	.mr_chart_container {
		flex: none !important;

		overflow: auto;
		overflow-y: clip;
		width: 100% !important;
		height: 90% !important;
		flex-flow: nowrap;

		&::-webkit-scrollbar-thumb {
			background: #c2bcc2 !important; /* 스크롤바의 색상 */
			width: 90% !important; /* 스크롤바의 너비 */
			border-radius: 10px !important;
		}
		&::-webkit-scrollbar {
			width: 90% !important; /* 스크롤바의 너비 */
			height: 9.4px !important; /* 스크롤바의 높이 */
		}
		&::-webkit-scrollbar-track {
			/* background: #ccc; 스크롤바 뒷 배경 색상 */
			background: transparent;
		}
	}
	.mr_chart_container .layout {
		min-width: unset;
	}

	.mr_bar_container {
		display: flex;
		flex-direction: column;
		margin: 0.5rem 0;
	}

	.mr_bar_outer {
		position: relative;
		width: 100%;
		background-color: #dedede;
		height: 20px;
		border-radius: 20px;
		margin: 0.3rem 0;
		justify-content: space-between;
		display: flex;
		align-items: center;
	}
	.mr_bar_inner {
		display: flex;
		width: 20%;
		height: 20px;
		background-color: #06a2ff;
		border-radius: 20px;
		padding: 0.1rem 0.5rem;
		.mr_bar_inner_txt_left {
			/* height: 100%; */
			width: fit-content;
			color: white;
			font-size: 12px;
			font-weight: bolder;
		}
	}
	.mr_left_bottom_item {
		background-color: #fafbfd;
		border-radius: 10px;
		justify-content: center;
		align-items: center;
		padding: 0.7rem;
		&:first-child {
			margin-right: 12px !important;
		}
	}

	.mr_bar_inner_txt_right {
		position: absolute;
		right: 0;
		width: 23.20954907161804%;
		border-radius: 9px;
		background-color: #dedede;
		color: #959595;
		border: 2px solid white;
		height: 100%;
		font-size: 10px;
		text-align: right;
		padding: 1px;
		max-width: 35px;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.mr_bar_inner_grade {
		position: absolute;
		left: -14px;
		font-weight: bolder;
	}
	.apexcharts-legend {
		flex-wrap: nowrap !important; /* 줄 바꿈을 방지 */

		overflow: auto;
		width: 100%;
		height: 100%;
	}
	.mrg_mid_txt {
		font-size: 12px;
	}

	.mrg_big_txt {
		font-size: 14px;
		font-weight: bold;
	}
	.mrg_bigger_txt {
		font-size: 16px;
		font-weight: bold;
	}

	.mr_inne_item {
		margin: 0 0.5rem;
		justify-content: center;
		align-items: center;
	}
	.mr_top_inner_right_item {
		align-items: center;
		justify-content: center;

		div:nth-child(1) {
			color: #727272;
		}
		div:nth-child(2) {
			color: #23318a;
		}
	}

	.mrg_medium_txt {
		font-size: 16px;
		font-weight: bolder;
	}
	.sub_header {
		font-size: 14px;
		font-weight: 800;
	}

	/* TOP */
	.mr_inner_two_item {
		align-items: center;
		justify-content: center;
		& > span:first-child {
			font-size: 12px;
			font-weight: 600;
			margin-right: 0.4rem;
		}
		& > span:nth-child(2) {
			margin-left: 4px;
			font-size: 20px;
			font-weight: 700;
		}
	}
	.mr_inner_three_item {
		align-items: center;
		justify-content: center;
		& > span:first-child {
			font-size: 12px;
			font-weight: 700;
		}
		& > span:nth-child(2) {
			margin-left: 4px;
			font-size: 16px;
			font-weight: 700;
		}
		& > span:nth-child(3) {
			margin-left: 1px;
			font-size: 12px;
			font-weight: 700;
		}
	}
	.mr_inner_small_two_items {
		width: 50%;
		display: flex;
		flex-flow: column nowrap;
		&:first-child {
			margin-right: 15px;
		}
		& > div {
			font-size: 12px;
			font-weight: bold;
			display: flex;
			flex-flow: row nowrap;
			& > span:first-child {
				color: #7d7d7d;
				margin-right: 8px;
			}
			& > span:nth-child(2) {
				color: #000000;
			}
		}
	}
	.mr_inner_left_three_colors > div {
		&:first-child {
			color: #6dc8ff;
		}
		&:nth-child(2) {
			color: #1fabff;
		}
		&:nth-child(3) {
			color: #974afe;
		}
	}
	.mr_inner_right_four_colors > div {
		&:first-child {
			color: #1fabff;
		}
		&:nth-child(2) {
			color: #127b12;
		}
		&:nth-child(3) {
			color: #ffaf53;
		}
		&:last-child {
			color: #7d7d7d;
		}
	}

	.mrg_top_inner_item_top {
		border-radius: 6px;
		background-color: #f2f4f6;
		color: #075c7c;
		font-size: 14px;
		font-weight: 800;
		text-align: start;
		width: fit-content;
		margin-bottom: none;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		padding: 12px 9px 9px 11px;
		height: 20.63492063492063%;
	}
	.mrg_top_inner_item_bottom {
		border-radius: 9px;
		background-color: #f2f4f6;
		border-top-left-radius: 0;
		height: 79.36507936507937%;
		padding: 8px 7px 7px 10.6px;
	}
	.mr_inner_item_bottom_left {
		background-color: #ffffff;
		border-radius: 6px;
		align-items: center;
		color: #2986aa;
		margin: 0 6px 0 9px;
		padding: 4px 6px;
	}
	.mr_inner_item_bottom_right {
		background-color: #ffffff;
		border-radius: 6px;
		align-items: center;
		color: #2986aa;
	}
	.mrg_top_inner_center {
		width: 47.17948717948718%;
	}
	.mrg_top_inner_left {
		margin-right: 13px !important;
		width: 43.78205128205128%;
		font-size: 10px;
		font-weight: 600;
		/* padding: 0.5rem 0; */
		/* border-radius: 0.5rem; */
		/* margin: 0 0.7rem; */
	}
	.mrg_top_inner_right {
		width: 9.03846153846154%;
		min-width: 138px;
		font-size: 10px;
		font-weight: 600;
		border-radius: 0.5rem;
		padding: 0.5rem 1.4rem;
		border: 1px solid #ccc;
		align-self: flex-end;
		min-height: 4.5rem;
		justify-content: center;
	}
	.mrg_top_inner_right_wrapper {
		flex-flow: row nowrap;
		align-items: center;
		justify-content: center;
		display: flex;
	}
	.mrg_top_inner_right_inner {
		margin: 0 15px;
		height: 100%;
		padding: 0.2rem 0.8rem;
		border-radius: 0.5rem;
	}
	.mrg_top_inner_center_inner {
		padding: 0.2rem 0.8rem;
		height: 100%;
		border-radius: 0.5rem;
	}
	.custom_btn {
		background-color: #323153;
		color: white !important;
	}

	.mr_gray_bg {
		background-color: #f5f5f5;
	}
	.mr_white_bg {
		background-color: #fafbfd;
	}

	.mrg_left_container {
		width: 32.86890436985434%;
	}
	.mrg_right_container {
		width: 67.13109563014566%;
	}

	.marketing_report_graph_top {
		width: 100%;
		height: 10%;
		border-radius: 0.8rem;
		display: block;
		background-color: #fafbfd;

		align-items: center;
		white-space: nowrap;
		overflow-x: hidden;
		overflow-y: hidden;
		min-height: 74px;
	}
	.marketing_report_graph_left_top {
		background-color: #fafbfd;
		border-radius: 10px;
		width: 100%;
		height: 36.20071684587814%;
		padding: 0.7rem;
	}

	.mr_float_state_item {
		overflow-x: auto;
		overflow-y: clip;
	}

	.mr_float_state {
		width: 100%;
		display: flex;
		align-items: center;
		white-space: nowrap;
		&.team_style {
			z-index: 100;
			width: 0px;
			left: 600px;
		}
		& > div {
			flex-flow: row nowrap;
		}
	}
	.mr_float_inner {
		margin-right: 0.5rem;
		display: flex;
		align-items: center;
	}
	.mr_float_inner_square {
		color: #06a2ff;
		font-size: 10px;
		margin: 0 0.2rem;
	}

	.mr_big_bar {
		height: 100%;
		width: 100%;
		flex: 1;
		align-content: center;
	}
	.mr_column_graph {
		position: relative;
		bottom: 350px;
		left: -10px;
		.apexcharts-canvas > .apexcharts-tooltip {
			z-index: 9999;
		}
	}

	.marketing_report_graph_left_bottom {
		display: flex;
		flex-flow: row nowrap;
		border-radius: 5px;
		width: 100%;
		height: 63.79928315412186%;
	}
	.marketing_report_graph_right_top {
		background-color: #fafbfd;
		border-radius: 10px;
		width: 100%;
		height: 63.19569120287253%;
		height: 430.722px !important;
		padding: 0.7rem;
		padding-bottom: 0;
		overflow: hidden;
	}

	.marketing_report_graph_right_bottom {
		background-color: #fafbfd;
		border-radius: 10px;
		width: 100%;
		height: 36.80430879712747%;
		padding: 0.7rem;
	}

	.mrg_report_rigth_top_wrapper {
		width: 100%;
		// align-items: center;
		flex-flow: nowrap;
		position: relative;
		height: 100%;
	}

	.mr_line_container {
		overflow-x: auto;
		overflow-y: clip;
		margin-left: 20px;
	}
	/* 색상 */
	.mr_blue_500 {
		color: #06a2ff;
	}
	.mr_blue_600 {
		color: #06a2ff;
	}
	.mr_blue_700 {
		color: #06a2ff;
	}
	.mr_blue_800 {
		color: #092aff;
	}
	.mr_blue_800 {
		color: #23318a;
	}
	.mr_green_700 {
		color: #127b12;
	}
	.mr_orange_700 {
		color: #ff9419;
	}
	.mr_red_700 {
		color: #ff4a00;
	}
	.mr_gray_700 {
		color: #7d7d7d;
	}
	.mr_aqua_600 {
		color: #4abcd9;
	}
	.mr_aqua_700 {
		color: #2986aa;
	}
}
</style>
